"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirm = exports.makeProgram = void 0;
const anchor_1 = require("@project-serum/anchor");
const did_registry_1 = require("../types/did_registry");
const constants_1 = require("./constants");
const makeProgram = (connection, wallet) => {
    return new anchor_1.Program(did_registry_1.IDL, constants_1.DID_REGISTRY_PROGRAM_ID, new anchor_1.AnchorProvider(connection, wallet, {}));
};
exports.makeProgram = makeProgram;
const confirm = (connection, txSig) => __awaiter(void 0, void 0, void 0, function* () {
    const blockhash = yield connection.getLatestBlockhash();
    yield connection.confirmTransaction(Object.assign(Object.assign({}, blockhash), { signature: txSig }), "confirmed");
});
exports.confirm = confirm;
//# sourceMappingURL=util.js.map